import apiClient from './client';
import type { ApiResponse } from '../types';
import type { AdminSearchUser } from '../types/impersonation';

/**
 * Search users across all organizations (SA only)
 * @param query - Email or name to search for (min 2 chars)
 */
export async function searchUsers(query: string): Promise<AdminSearchUser[]> {
  const response = await apiClient.get<ApiResponse<AdminSearchUser[]>>(
    '/api/v1/admin/users/search',
    { params: { q: query, limit: 20 } }
  );
  if (!response.data.success || !response.data.data) {
    throw new Error('Failed to search users');
  }
  return response.data.data;
}

/**
 * Get detailed user info for impersonation preview (SA only)
 */
export async function getUserDetails(userId: string): Promise<AdminSearchUser> {
  const response = await apiClient.get<ApiResponse<AdminSearchUser>>(
    `/api/v1/admin/users/${encodeURIComponent(userId)}`
  );
  if (!response.data.success || !response.data.data) {
    throw new Error('Failed to get user details');
  }
  return response.data.data;
}
